// Scheduler Main content component
import { useRef } from 'react';

import clsx from 'clsx';

import JobsList from '@/components/Job/JobsList';
import OperatorSearchWidget from '@/components/OperatorSearch/OperatorSearchWidget';

import { useEditSchedulerContext } from '@/context/EditSchedulerContext';

import { useShouldScroll } from '@isd/lib/helpers/hooks';

export default function SchedulerMain() {
  const { selectedGroup, selectedJob } = useEditSchedulerContext();
  const jobsListContainer = useRef<HTMLDivElement | null>(null);
  const shouldScrollJobsList = useShouldScroll(jobsListContainer);

  return (
    <div className="scheduler-main relative grid h-full grid-cols-4 justify-center">
      {!!selectedJob && selectedGroup !== null && (
        <div className="col-span-1 hidden pt-2 pl-1 md:block lg:pl-5">
          <OperatorSearchWidget />
        </div>
      )}
      <div
        ref={jobsListContainer}
        className={clsx(
          'jobs-list-container col-span-4 overflow-x-hidden px-2 md:py-6',
          'transition-all', // Animate expansion and contraction of Jobs List
          shouldScrollJobsList && 'overflow-y-scroll',
          selectedGroup === null
            ? 'xl:px-10' // Search widget closed
            : 'md:col-span-3' // Search widget open
        )}
      >
        <JobsList />
      </div>
    </div>
  );
}
